module.exports = __webpack_public_path__ + "static/media/zl_2_10.09424288.png";